import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RatingsReviewsService';
import { query, serviceQueries } from '@estee/elc-service-bus';
import { Config } from '~domain/entities/Config';

export class ConfigRepository {
    private config: Config;

    constructor() {
        this.config = diContainer.get(serviceNames.config);
    }

    public getConfigs = async (configs: string[]) => {
        const config = await query(serviceQueries.GET_CONFIG, configs);

        this.config.updateConfig(config);
    };
}
